import { canonicalFormType, PORTAL_PATH_BY_FORM_TYPE } from './formTypeIds';

export function portalBaseUrl() {
  return (
    process.env.REACT_APP_PORTAL_URL
    || (typeof window !== 'undefined' ? window.location.origin : 'https://portal.keyflo.ai')
  ).replace(/\/$/, '');
}

export function portalPathForEntity(entityType, formType) {
  const key = String(entityType || formType || '').trim().toLowerCase();
  const canonical = canonicalFormType(key);
  if (PORTAL_PATH_BY_FORM_TYPE[canonical]) return PORTAL_PATH_BY_FORM_TYPE[canonical];
  if (key === 'contract' || key === 'purchase_agreement') return 'contract';
  if (key === 'buyer_agreement' || key === 'buyer-agreement') return 'buyer-agreement';
  if (key === 'listing' || key === 'listing_agreement') return 'listing';
  return null;
}

export function sessionShowsCompleted(session) {
  return session?.status === 'submitted';
}

export function splitIdFromCompletion(session, result = {}) {
  return result.split_attachment_id
    || result.splitAttachmentId
    || session?.split_attachment_id
    || session?.splitAttachmentId
    || null;
}

export function portalHrefForEntity({ entityId, entityType, formType, splitAttachmentId } = {}) {
  const portal = portalBaseUrl();
  const path = portalPathForEntity(entityType, formType);
  if (!(entityId && path)) return portal;
  const href = `${portal}/${path}/${entityId}`;
  return splitAttachmentId ? `${href}?openDoc=${splitAttachmentId}` : href;
}
